/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AIDatasetDetailReference,
    AIDatasetDetailReferenceFromJSON,
    AIDatasetDetailReferenceFromJSONTyped,
    AIDatasetDetailReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AICategoryDetailUpdate
 */
export interface AICategoryDetailUpdate {
    /**
     * 
     * @type {AIDatasetDetailReference}
     * @memberof AICategoryDetailUpdate
     */
    dataset: AIDatasetDetailReference;
    /**
     * 
     * @type {string}
     * @memberof AICategoryDetailUpdate
     */
    name: string;
}

export function AICategoryDetailUpdateFromJSON(json: any): AICategoryDetailUpdate {
    return AICategoryDetailUpdateFromJSONTyped(json, false);
}

export function AICategoryDetailUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AICategoryDetailUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dataset': AIDatasetDetailReferenceFromJSON(json['dataset']),
        'name': json['name'],
    };
}

export function AICategoryDetailUpdateToJSON(value?: AICategoryDetailUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dataset': AIDatasetDetailReferenceToJSON(value.dataset),
        'name': value.name,
    };
}


